import script from "./OrderContactTile.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderContactTile.vue?vue&type=script&setup=true&lang=js"

import "./OrderContactTile.vue?vue&type=style&index=0&id=067f4cc7&lang=scss"

const __exports__ = script;

export default __exports__